<template>
<CCard class="box-shadow-card w-100 h-100">
  <div class="d-flex ">
    <h2>Payment Status is loading...</h2>
  </div>
</CCard>


</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import {
  COMPONENT_NAME,
  PATHNAME,
  ROUTER_PARAM,
  PAYMENT_PROCEED_TO,
  PROCEED_TO_TYPE,BOOKING_PAYMENT_STATUS, BOOKING_PAYMENT_ERRORS
} from "./../../../util/constants";
import router, { navigate, goBack } from "./../../../router/index";
import apiGetRechargeDetails from "./../../../services/apiGetRechargeDetails";
import cAlertModal from "./../../../components/form/cAlertModal";
import Logger from "./../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "./../../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import BaseConfiguration from "./../../../config/base";
import {
  handleJWT,
  getErrorAlertValue,
  handleSessionExist,
  addClassToBody,
  removeClassBody
} from "./../../../util/util";

export default {
  name: COMPONENT_NAME.PAYMENT_STATUS,
  data() {
    return {
      token: null,
      alertValue: null,
      isAlert: false
    };
  },
  components: {
    cAlertModal
  },

  computed: {
    ...mapGetters("sPrepaidTopUp", {
      GET_PRE_PAID_PAY_RES: "GET_PRE_PAID_PAY_RES"
    }),

    ...mapGetters("sPostPaidTopUp", {
      GET_POST_PAID_PAY_RES: "GET_POST_PAID_PAY_RES"
    })
  },
  methods: {
    ...mapActions("sPaymentStatus", {
      SET_RECHARGE_DET_RES: "SET_RECHARGE_DET_RES"
    }),

    async getRechargeDetails(pToken) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRechargeDetails");
        let rechargeDetReq = apiGetRechargeDetails.buildRequest(pToken);

        if (rechargeDetReq) {
          let rechargeDetRes = await apiGetRechargeDetails.getResponse(
            rechargeDetReq
          );

          if (VALIDATE_SUCCESS_RES(rechargeDetRes)) {
            retValue = rechargeDetRes.data;
            this.SET_RECHARGE_DET_RES(retValue);
            if (retValue.data.proceedTo) {
              this.navByProceedTo(retValue.data);
            } else {
              navigate(PATHNAME.FAILED_PAY);
              throw "Invalid proceedTo ";
            }
          } else {
            //if status error
            retValue = rechargeDetRes.data;

            let error = getErrorMessage(rechargeDetRes);

            let isJwt = handleJWT(error);
            if (!isJwt && rechargeDetRes) {
              let isSessionExpired = handleSessionExist(rechargeDetRes.data);
              if (!isSessionExpired) {
                // this.alertValue=getErrorAlertValue(error);
                this.SET_RECHARGE_DET_RES(retValue);
                if (retValue.data&&retValue.data.proceedTo) {
                  this.navByProceedTo(retValue.data);
                } else {
                   navigate(PATHNAME.FAILED_PAY);
                  throw "Invalid ProceedTo ";
                }
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENT_STATUS,
          "error in getRechargeDetails",
          err.toString(),
          "getRechargeDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///navigate to corresponding pages using proceedTo from recharge details response
    navByProceedTo(pRechargeDetRes) {
      try {
        if (BaseConfiguration.isDebug) console.log("navByProceedTo");
        let param = {};
        switch (pRechargeDetRes.proceedTo) {
          case PAYMENT_PROCEED_TO.ERROR_PAGE:
            {
              navigate(PATHNAME.FAILED_PAY);
            }
            break;
          case PAYMENT_PROCEED_TO.PAYMENT_PAGE:
            {
              if (this.GET_POST_PAID_PAY_RES) {
                navigate(PATHNAME.AGENT_DEPOSIT);
              } else if (this.GET_PRE_PAID_PAY_RES) {
                navigate(PATHNAME.TOPUP);
              } else {
                 navigate(PATHNAME.FAILED_PAY);
                throw "invalid navigation for proceedTo:" +
                  PAYMENT_PROCEED_TO.PAYMENT_PAGE;
              }
            }
            break;

          case PAYMENT_PROCEED_TO.SUCCESS_PAGE:
            {
              navigate(PATHNAME.SUCCESS_PAY);
            }
            break;

          case PAYMENT_PROCEED_TO.PENDING_PAGE:
            {
              navigate(PATHNAME.PENDING_PAY);
            }
            break;

          default:
              navigate(PATHNAME.FAILED_PAY);
            throw "unhandled proceedTo : " +pRechargeDetRes.proceedTo;
            break;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENT_STATUS,
          "error in navByProceedTo",
          err.toString(),
          "navByProceedTo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///logger status,error,sessId,orderId,orderPaymentId,authToken if there is no token in query string
  loggerFunc() {
    
      try {
        if(BaseConfiguration.isDebug) console.log("loggerFunc");
        let status = this.$router.currentRoute.query[ROUTER_PARAM.STATUS];
        let error = this.$router.currentRoute.query[ROUTER_PARAM.ERROR];
        let sessionId = this.$router.currentRoute.query[ROUTER_PARAM.SESSION_ID];
        let providerId = this.$router.currentRoute.query[ROUTER_PARAM.PROVIDER_ID];
        let orderPaymentId = this.$router.currentRoute.query[ROUTER_PARAM.ORDER_PAYMENT_ID];
        let authToken = this.$router.currentRoute.query[ROUTER_PARAM.AUTHTOKEN];
        
        for (var index in BOOKING_PAYMENT_ERRORS.ERRORS) {
          if(BOOKING_PAYMENT_ERRORS.ERRORS[index]==error) {
            error=index;
          }
          
        }
         let body= { 
           status : status,
          error : error,
          sessionId : sessionId,
         providerId : providerId,
         orderPaymentId : orderPaymentId,
         authToken : authToken,
         }
         

        navigate(PATHNAME.FAILED_PAY);
        throw body;
          

      } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.BOOKING_STATUS_PAGE,
                  "no token has received",
                  JSON.stringify(err),
                  "loggerFunc",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
  }


  },

  mounted() {
    this.$root.$emit("toggle-sidebar-minimize");
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.$root.$emit("toggle-sidebar-minimize");
      this.token = this.$router.currentRoute.query[ROUTER_PARAM.TOKEN];
// this.token ='eiuwrtuyewrteiuwryeiuwr';
      if (this.token) {
        let rechargeDetailRes = await this.getRechargeDetails(this.token);
      }
       /// if there is no token
          else{
            this.loggerFunc();  
          }
    
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.PAYMENT_STATUS,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  beforeCreate() {
    addClassToBody(COMPONENT_NAME.PAYMENT_STATUS);
  },

  beforeDestroy() {
             this.$root.$emit("toggle-sidebar-minimize", true);

    removeClassBody();
  }
};
</script>